/**
 * Skip Brain Admin - Application Component
 *
 * MJ 4.0 Minimal App Shell Pattern:
 * Uses @memberjunction/ng-explorer-app for the full Explorer shell.
 * Tree-shaking prevention is handled by the Class Registration Manifest system.
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-root',
  template: '<mj-explorer-app />'
})
export class AppComponent {}
